module.exports = __webpack_public_path__ + "static/img/per-img.4937dcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/common/per-img.png
// module id = nR5Z
// module chunks = 1